import { PureComponent } from 'react';

import Html from 'Component/Html';

import BlackFridayTop from 'Component/BlackFridayTop';
import BlackFridayScrollTop from 'Component/BlackFridayScrollTop';

import './BlackFriday.style';

export class BlackFriday extends PureComponent {
    renderContent() {
        const { page: { content } } = this.props;

        return <Html content={ content } />;
    }

    render() {
        const { isLoading, page: { content } } = this.props;

        if (isLoading) {
            return 'Loading...'
        }

        if (!isLoading && !content) {
            return null;
        }

        return (
            <main block="BlackFriday">
                {/*<BlackFridayTop />*/}
                { this.renderContent() }
                <BlackFridayScrollTop />
            </main>
        );
    }
}

export default BlackFriday;
